import React from 'react';
import PropTypes from 'prop-types';
import { Actions } from '../reducers';
import { PAGES } from '../lib/constants';
import styles from './errorMessage.scss';

const hideError = dispatch => e => {
  e.preventDefault();
  dispatch(Actions.hideErrorMessage());
};

const ErrorMessage = (props) => {
  const { login: loginError, signup: signupError } = props.staticData.rejectError;
  let message = props.page === PAGES.LOGIN ? loginError : signupError;
  if (props.internalError) {
    message = props.staticData.internalError;
  }
  return (
    <div className={`alert alert-main alert-error ${styles.errorDiv}`} >
      <button className="close" onClick={hideError(props.dispatch)} >×</button>
      <p className="flash-message">{ message }</p>
    </div>
  );
};

ErrorMessage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  staticData: PropTypes.object.isRequired,
  internalError: PropTypes.bool.isRequired,
};

export default ErrorMessage;
